import { render, staticRenderFns } from "./ViqMessageUser.vue?vue&type=template&id=03e014c0&scoped=true"
import script from "./ViqMessageUser.vue?vue&type=script&lang=js"
export * from "./ViqMessageUser.vue?vue&type=script&lang=js"
import style0 from "./ViqMessageUser.vue?vue&type=style&index=0&id=03e014c0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e014c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03e014c0')) {
      api.createRecord('03e014c0', component.options)
    } else {
      api.reload('03e014c0', component.options)
    }
    module.hot.accept("./ViqMessageUser.vue?vue&type=template&id=03e014c0&scoped=true", function () {
      api.rerender('03e014c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqMessageUser.vue"
export default component.exports